import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  showChartAccountModalForAddEdit,
  showChartAccountModalForDelete,
} from './store/actions';

import { ChartAccountPropTypes } from './propTypes';

class ChartOfAccountsAdminColumnRenderer extends PureComponent {
  static propTypes = {
    data: ChartAccountPropTypes.isRequired,
    showChartAccountModalForAddEdit: PropTypes.func.isRequired,
    showChartAccountModalForDelete: PropTypes.func.isRequired,
    node: PropTypes.shape({
      rowIndex: PropTypes.number.isRequired,
    }),
  };

  showChartAccountModalForEdit = () => {
    const { data: chartAccount, showChartAccountModalForAddEdit } = this.props;

    showChartAccountModalForAddEdit(chartAccount);
  };

  showChartAccountModalForDelete = () => {
    const { data, showChartAccountModalForDelete, node } = this.props;
    showChartAccountModalForDelete({
      chartName: data.chartName,
      localAccount: data.localAccount,
      localAccountDescription: data.localAccountDescription,
      period: data.periodName,
      rowIndex: node.rowIndex,
    });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Chart Account"
          onClick={this.showChartAccountModalForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Chart Account"
          onClick={this.showChartAccountModalForDelete}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  {
    showChartAccountModalForAddEdit,
    showChartAccountModalForDelete,
  }
)(ChartOfAccountsAdminColumnRenderer);
